import { FreeGameType } from '../enum/buyBonusEnum'

const BetOptionMultiMap = new Map<FreeGameType, number>([
  [FreeGameType.MainGame, 1],
  [FreeGameType.YummyFreeGame, 60],
  [FreeGameType.HeavenlyFreeGame, 120],
])
export const getPayStake = (stake: number, betOptionType: FreeGameType): number => {
  const betOptionMulti = BetOptionMultiMap.get(betOptionType) || 1
  return stake * betOptionMulti
}
